
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/midas-near-me",
      function () {
        return require("private-next-pages/midas-near-me/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/midas-near-me"])
      });
    }
  